// The "Enterprise" mega-menu (desktop + mobile), between "AI & Agentic" and
// "Company". Kept in a plain .ts module (not Navbar.tsx) so tests can import it
// and check every href resolves to a real route. Item labels are translated in
// ms.json / zh.json under nav.linkLabels, keyed by href; group labels under
// nav.labels.

export interface EnterpriseMenuItem {
  href: string;
  label: string;
}

export interface EnterpriseMenuGroup {
  label: string;
  items: EnterpriseMenuItem[];
}

export const ENTERPRISE_MENU_GROUPS: EnterpriseMenuGroup[] = [
  {
    label: "Buy",
    items: [
      { href: "/enterprise/", label: "Enterprise directory" },
      { href: "/enterprise/sonarqube-malaysia/", label: "SonarQube" },
      { href: "/enterprise/microsoft-malaysia/", label: "Microsoft" },
      { href: "/enterprise/red-hat-malaysia/", label: "Red Hat" },
      { href: "/enterprise/dgx-spark-malaysia/", label: "DGX Spark" },
      { href: "/enterprise/rtx-spark-laptops-malaysia/", label: "RTX Spark laptops" },
      { href: "/enterprise/nvidia-malaysia/", label: "NVIDIA GPUs" },
    ],
  },
  {
    label: "Compliance",
    items: [
      { href: "/compliance/", label: "Compliance hub" },
      { href: "/ai-governance/", label: "AI governance" },
      { href: "/compliance/bnm-rmit/", label: "BNM RMiT guide" },
      { href: "/blog/rmit-source-code-review-malaysia/", label: "RMiT source code review" },
    ],
  },
  {
    label: "Services",
    items: [
      { href: "/services/enterprise-resilience/", label: "Enterprise Resilience Assessment" },
      { href: "/enterprise/sonarqube-malaysia/#training", label: "SonarQube setup & training" },
    ],
  },
];

export const ENTERPRISE_MENU_LINKS: EnterpriseMenuItem[] = ENTERPRISE_MENU_GROUPS.flatMap(
  (group) => group.items,
);

// Paths that light up the "Enterprise" top-level item.
export const ENTERPRISE_ACTIVE_PATHS = ["/enterprise", "/compliance"];
